import * as React from "react";
import { SVGProps } from "react";

const Scan: React.FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.89535 15.814C1.13256 15.814 0.5 15.1814 0.5 14.4186V9.76744C0.5 4.37209 4.8907 0 10.2674 0H14.9186C15.6814 0 16.314 0.632558 16.314 1.39535C16.314 2.15814 15.6814 2.7907 14.9186 2.7907H10.2674C6.41628 2.7907 3.2907 5.91628 3.2907 9.76744V14.4186C3.2907 15.1814 2.65814 15.814 1.89535 15.814Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M39.1047 15.814C38.3419 15.814 37.7093 15.1814 37.7093 14.4186V9.76744C37.7093 5.91628 34.5837 2.7907 30.7326 2.7907H26.0814C25.3186 2.7907 24.686 2.15814 24.686 1.39535C24.686 0.632558 25.3186 0 26.0814 0H30.7326C36.1093 0 40.5 4.37209 40.5 9.76744V14.4186C40.5 15.1814 39.8674 15.814 39.1047 15.814Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M30.7326 40H27.9419C27.1791 40 26.5465 39.3674 26.5465 38.6047C26.5465 37.8419 27.1791 37.2093 27.9419 37.2093H30.7326C34.5837 37.2093 37.7093 34.0837 37.7093 30.2326V27.4419C37.7093 26.6791 38.3419 26.0465 39.1047 26.0465C39.8674 26.0465 40.5 26.6791 40.5 27.4419V30.2326C40.5 35.6279 36.1093 40 30.7326 40Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M14.9186 40H10.2674C4.8907 40 0.5 35.6279 0.5 30.2326V25.5814C0.5 24.8186 1.13256 24.186 1.89535 24.186C2.65814 24.186 3.2907 24.8186 3.2907 25.5814V30.2326C3.2907 34.0837 6.41628 37.2093 10.2674 37.2093H14.9186C15.6814 37.2093 16.314 37.8419 16.314 38.6047C16.314 39.3674 15.6814 40 14.9186 40Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M24.2209 31.6279H16.7791C12.2767 31.6279 9.80233 29.1535 9.80233 24.6512V15.3488C9.80233 10.8465 12.2767 8.37209 16.7791 8.37209H24.2209C28.7233 8.37209 31.1977 10.8465 31.1977 15.3488V24.6512C31.1977 29.1535 28.7233 31.6279 24.2209 31.6279ZM16.7791 11.1628C13.8395 11.1628 12.593 12.4093 12.593 15.3488V24.6512C12.593 27.5907 13.8395 28.8372 16.7791 28.8372H24.2209C27.1605 28.8372 28.407 27.5907 28.407 24.6512V15.3488C28.407 12.4093 27.1605 11.1628 24.2209 11.1628H16.7791Z"
      fill="#1A1C1F"
      className={props.className}
    />
    <path
      d="M33.5233 21.3953H7.47674C6.71395 21.3953 6.08139 20.7628 6.08139 20C6.08139 19.2372 6.71395 18.6046 7.47674 18.6046H33.5233C34.286 18.6046 34.9186 19.2372 34.9186 20C34.9186 20.7628 34.286 21.3953 33.5233 21.3953Z"
      fill="#1A1C1F"
      className={props.className}
    />
  </svg>
);

export default Scan;
